import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormMedida from './FormMedida';

import updateMedida from '../../../../graphql/mutations/otros/updateMedida.graphql';
import getMedidaPorId from '../../../../graphql/querys/otros/getMedidaPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateMedida, {
  name: 'updateMedida',
})
class EditarMedida extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
    };

    this.props.client
      .query({
        query: getMedidaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const medida = res.data.getMedidaPorId;

        this.setState({
          loading: false,
          medida: medida,
        });
      })
      .catch(err => {
        console.log('Error al obtener la medida');
        console.log(err);
        errorService(err, { _id: this.props.match.params.id });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarMedida = this.guardarMedida.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarMedida(medida) {
    this.setState(
      {
        medida: {
          ...this.state.medida,
          ...medida,
        },
      },
      function() {
        let nuevaMedida = this.state.medida;
        delete nuevaMedida.__typename;
        delete nuevaMedida._id;

        this.props
          .updateMedida({
            variables: {
              _id: this.props.match.params.id,
              nuevaMedida: this.state.medida,
            },
          })
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos de la medida',
            });

            this.props.history.push('/admin/otros/medidas');
          })
          .catch(err => {
            console.log('Error en la actualizacion de la medida');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevaMedida: this.state.medida,
            });
            Modal.error({
              title: 'Error en la actualizacion de la medida',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Medida</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Medida
          </h2>
          <br />
          <div style={estiloContent}>
            <FormMedida
              className="formularios"
              onSubmit={this.guardarMedida}
              onAnterior={() =>
                this.props.history.push('/admin/otros/medidas')
              }
              datos={this.state.medida}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarMedida);
